/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable indent */
import PropTypes from 'prop-types'
import USBPhoneInput from '@usb-inner-src/react-forms-input-phone'
import USBAddressCollection from '@usb-ui-tools/react-forms-collection-address'
import USBAccountNumberInput from '@usb-ui-tools/react-forms-input-account-number'
import USBBusinessNameInput from '@usb-ui-tools/react-forms-input-business-name'
import { BlockLayout } from '@usb-ui-tools/react-billpay-layout'
import { useState, useEffect } from 'react'
import { useMultilingualService } from '../../../../service/multilingualService'
import {
  getFieldErrorMessage,
  incrementErrorCountsForFieldLevelError
} from '../../../../utils/errorMapping'
import { isOLBOrIpadApp } from '../../../../utils/browserutils'
import './details.scss'
import getUSBExBillerLogo from '../../../../utils/extBillerLogo'

/**
 * Returns contact information
 * @method
 * @param {Object} intl - locale of DashboardNearbyMarchants
 * @param {Object} phoneNumberRef - referance of phone number element
 * @param {Number} phoneNumberErrorCount - to render the error
 * @param {Object} formValues - address field valus
 * @param {Function} handleStatusUpdate - handler for input update
 * @param {Number} addressCollectionErrorCount - to render the error
 * @param {Object} addressCollectionRef - reference of the address element
 * @param {String} googleAPIkey - google api key for address
 * @param {Object} fieldLevelErrorData - field level error data object
 * @param {Object} isPayeeCategoryBusiness - to check if the payee add via serch or not
 * @returns {HTMLElement} Returns segment with contact information
 */
const EditDetails = ({
  name,
  setName,
  companyRef,
  personNameRef,
  companyErrorCount,
  personNameErrorCount,
  phoneNumberRef,
  isHideAccountNumber,
  accountNumberRef,
  accountNumberErrorCount,
  addressCollectionRef,
  nickName,
  setNickName,
  payee,
  billerLogoUrl,
  formValues,
  handleStatusUpdate,
  phoneNumberErrorCount,
  addressCollectionErrorCount,
  googleAPIkey,
  fieldLevelErrorData,
  isPayeeCategoryBusiness,
  isScheduled,
  isAutopayment,
  modifiableFields,
  isPersonBiller
}) => {
  // sorting  modifiableFields
  const first = 'name'
  modifiableFields.sort((x, y) => (x === first ? -1 : y === first ? 1 : 0))
  const { CONTACT, DETAILS, REMOVEBILLPOPUP } =
    useMultilingualService('editBill')

  useEffect(() => {
    accountNumberRef?.current
      ?.querySelector('input')
      ?.classList?.add('glance_masked')
  }, [accountNumberRef])

  // To remove ecncrypting account number after first instance
  const [encryptedAccValue] = useState(formValues.accountNumber.inputValue)
  const newEncryptedAccValue = encryptedAccValue?.replace(/[*]/g, '•')
  return (
    <>
      <BlockLayout
        actAs="CardChild"
        contentOnTop={
          <p
            className="usb-c-gray-80"
            style={{
              marginBottom: isPersonBiller ? '28px' : '16px',
              fontSize: '16px'
            }}
            aria-label={CONTACT?.EDIT_CONTACT}
            tabIndex={0}
          >
            {CONTACT?.EDIT_CONTACT}
          </p>
        }
        gapOnBottom="0"
      >
        {modifiableFields && modifiableFields?.length && (
          <>
            {isOLBOrIpadApp() && (
              <div
                aria-atomic="true"
                id="addbillinfo-logo"
                style={{ display: 'flex', borderBottom: '1px solid #CDCDD3' }}
              >
                <div
                  aria-atomic="true"
                  id="addbillinfo-logo"
                  style={{ display: 'flex', paddingBottom: '12px' }}
                  tabIndex={0}
                >
                  <img
                    name="logo"
                    src={getUSBExBillerLogo(billerLogoUrl)}
                    alt="biller logo"
                    style={{ height: '2.5rem', width: '2.5rem' }}
                  />
                  <h1
                    id="addbillinfo-heading"
                    aria-label={payee?.displayName}
                    style={{ margin: 'auto 10px 5px 10px', color: '#555555' }}
                    className="usb-tg-body-large usb-tg-bold"
                  >
                    {payee?.displayName || payee?.nickName}
                  </h1>
                </div>
              </div>
            )}

            <div
              style={{
                width: isOLBOrIpadApp() ? '77%' : ''
              }}
            >
              {modifiableFields.map((item) => (
                <>
                  {item?.toLowerCase() === 'name' ? (
                    isPersonBiller ? (
                      <USBBusinessNameInput
                        id="add-bill-manual-name-input"
                        ref={personNameRef}
                        inputName="person-name"
                        pattern="[^a-zA-Z0-9_(){}&@!+#.$,'% *-]"
                        labelText={DETAILS?.EDIT_PERSON_NAME}
                        statusUpdateCallback={(inputObj) => {
                          handleStatusUpdate(inputObj)
                          const { inputValue } = inputObj
                          setName(inputValue)
                        }}
                        errorMessages={{
                          default: DETAILS?.EDIT_BILL_PERSON_NAME_ERROR,
                          111: DETAILS?.EDIT_BILL_FILTER_PERSON_NAME_ERROR
                        }}
                        showFilterErrors
                        type="first"
                        dynamicErrorCount={personNameErrorCount}
                        dynamicValue={name}
                        key={`${personNameErrorCount}test`}
                      />
                    ) : (
                      <USBBusinessNameInput
                        id="add-bill-manual-business-input"
                        ref={companyRef}
                        inputName="business-name"
                        pattern="[^a-zA-Z0-9_(){}&@!+#.$,'% *-]"
                        labelText={DETAILS?.EDIT_COMPANY_NAME}
                        statusUpdateCallback={(inputObj) => {
                          handleStatusUpdate(inputObj)
                          const { inputValue } = inputObj
                          setName(inputValue)
                        }}
                        errorMessages={{
                          default: DETAILS?.EDIT_BILL_COMPANY_NAME_ERROR,
                          111: DETAILS?.EDIT_BILL_FILTER_COMPANY_NAME_ERROR
                        }}
                        type="first"
                        showFilterErrors
                        dynamicErrorCount={companyErrorCount}
                        dynamicValue={name}
                        key={`${companyErrorCount}test`}
                      />
                    )
                  ) : (
                    <></>
                  )}
                  {item?.toLowerCase() === 'accountnumber' &&
                    !isHideAccountNumber && (
                      <USBAccountNumberInput
                        id="edit-bill-accno-input "
                        ref={accountNumberRef}
                        // dynamicValue={formValues.accountNumber.inputValue}
                        initValue={formValues.accountNumber.inputValue || ''}
                        encryptedValue={newEncryptedAccValue}
                        inputName="account-number"
                        labelText={DETAILS?.EDIT_ACC_NUMBER}
                        statusUpdateCallback={(inputObj) => {
                          handleStatusUpdate(inputObj)
                        }}
                        errorMessages={{
                          default: getFieldErrorMessage(
                            DETAILS?.EDIT_ACCOUNT_ERROR,
                            fieldLevelErrorData,
                            'accountnumber',
                            'addEditErrors'
                          ),
                          112: getFieldErrorMessage(
                            DETAILS?.EDIT_FILTER_ACCOUNT_ERROR,
                            fieldLevelErrorData,
                            'accountnumber',
                            'addEditErrors'
                          ),
                          114: getFieldErrorMessage(
                            DETAILS?.EDIT_FILTER_ACCOUNT_ERROR,
                            fieldLevelErrorData,
                            'accountnumber',
                            'addEditErrors'
                          )
                        }}
                        showErrorMessage="every"
                        showFilterErrors
                        dynamicErrorCount={incrementErrorCountsForFieldLevelError(
                          fieldLevelErrorData,
                          'accountnumber',
                          accountNumberErrorCount
                        )}
                        isOptional={!!isPersonBiller}
                      />
                    )}

                  {item?.toLowerCase() === 'nickname' && (
                    <div id="wrapper_account-number">
                      <USBBusinessNameInput
                        id="edit-bill-nickname-input"
                        style={{ marginTop: '1rem' }}
                        dynamicValue={nickName || ''}
                        inputName="username"
                        pattern="[^a-zA-Z0-9 ,.'-]"
                        labelText={DETAILS?.EDIT_NICK_NAME}
                        statusUpdateCallback={(inputObj) => {
                          const { inputValue } = inputObj

                          setNickName(inputValue)
                        }}
                        errorMessages={{
                          default: `${DETAILS?.EDIT_NICK_NAME_ERROR}`
                        }}
                        isOptional
                        type="first"
                      />
                    </div>
                  )}

                  {item?.toLowerCase() === 'contactphonenumber' && (
                    <USBPhoneInput
                      id="edit-bill-contact-input"
                      ref={phoneNumberRef}
                      dynamicValue={formValues.phoneNumber.inputValue}
                      inputName="phone-input"
                      labelText={
                        !isPersonBiller
                          ? isPayeeCategoryBusiness
                            ? CONTACT?.EDI_MERCHANT_PHONE
                            : CONTACT?.EDI_COMPANY_PHONE
                          : CONTACT?.EDI_PERSON_PHONE
                      }
                      errorMessages={{
                        default: `${CONTACT?.EDIT_PHONR_ERROR_DEFAULT}`,
                        121: `${CONTACT?.EDIT_PHONR_ERROR_121}`,
                        201: `${CONTACT?.EDIT_PHONR_ERROR_201}`
                      }}
                      statusUpdateCallback={(inputObj) => {
                        handleStatusUpdate(inputObj)
                      }}
                      dataTestId="test-id"
                      showFilterErrors
                      dynamicErrorCount={phoneNumberErrorCount}
                      isOptional={!!isPayeeCategoryBusiness}
                    />
                  )}

                  {item?.toLowerCase() === 'address' &&
                    !isPayeeCategoryBusiness && (
                      <USBAddressCollection
                        id="edit-bill-address-section"
                        apiKey={googleAPIkey}
                        ref={addressCollectionRef}
                        physicalAddressRequired={false}
                        initValues={[
                          {
                            field: 'address1',
                            value:
                              formValues?.addressCollection?.address1
                                ?.inputValue || ''
                          },
                          {
                            field: 'address2',
                            value:
                              formValues?.addressCollection?.address2
                                ?.inputValue || ''
                          },
                          {
                            field: 'city',
                            value:
                              formValues?.addressCollection?.city?.inputValue ||
                              ''
                          },
                          {
                            field: 'state',
                            value:
                              formValues?.addressCollection?.state
                                ?.inputValue || ''
                          },
                          {
                            field: 'postalCode',
                            value:
                              formValues?.addressCollection?.postalCode
                                ?.inputValue
                          }
                        ]}
                        dynamicValues={[
                          {
                            field: 'address1',
                            value:
                              formValues?.addressCollection?.address1
                                ?.inputValue || ''
                          },
                          {
                            field: 'address2',
                            value:
                              formValues?.addressCollection?.address2
                                ?.inputValue || ''
                          },
                          {
                            field: 'city',
                            value:
                              formValues?.addressCollection?.city?.inputValue ||
                              ''
                          },
                          {
                            field: 'state',
                            value:
                              formValues?.addressCollection?.state
                                ?.inputValue || ''
                          },
                          {
                            field: 'postalCode',
                            value:
                              formValues?.addressCollection?.postalCode
                                ?.inputValue
                          }
                        ]}
                        collectionContent={[
                          {
                            field: 'address1',
                            label: `${
                              !isPersonBiller
                                ? isPayeeCategoryBusiness
                                  ? CONTACT?.EDIT_MERCHANT_ADDRESS
                                  : CONTACT?.EDIT_COMPANY_ADDRESS
                                : CONTACT?.EDIT_PERSON_ADDRESS
                            }`,
                            errors: {
                              default: getFieldErrorMessage(
                                CONTACT?.STREET_ERROR_DEFAULT,
                                fieldLevelErrorData,
                                'addressLine1',
                                'addEditErrors'
                              ),
                              112: getFieldErrorMessage(
                                CONTACT?.EDIT_STREET_ERROR,
                                fieldLevelErrorData,
                                'addressLine1',
                                'addEditErrors'
                              ),
                              114: getFieldErrorMessage(
                                CONTACT?.EDIT_STREET_ERROR,
                                fieldLevelErrorData,
                                'addressLine1',
                                'addEditErrors'
                              )
                            }
                          },
                          {
                            field: 'address2',
                            label: `${CONTACT?.EDIT_APT}`,
                            errors: {
                              default: `${CONTACT?.EDIT_ADDRESS2_ERROR}`
                            }
                          },
                          {
                            field: 'city',
                            label: `${CONTACT?.EDIT_CITY}`,
                            errors: {
                              default: getFieldErrorMessage(
                                CONTACT?.CITY_ERROR_DEFAULT,
                                fieldLevelErrorData,
                                'city',
                                'addEditErrors'
                              ),
                              112: getFieldErrorMessage(
                                CONTACT?.EDIT_CITY_ERROR,
                                fieldLevelErrorData,
                                'city',
                                'addEditErrors'
                              ),
                              114: getFieldErrorMessage(
                                CONTACT?.EDIT_CITY_ERROR,
                                fieldLevelErrorData,
                                'city',
                                'addEditErrors'
                              )
                            }
                          },
                          {
                            field: 'state',
                            label: `${CONTACT?.EDIT_STATE}`,
                            placeholder: 'Select state',
                            errors: {
                              default: getFieldErrorMessage(
                                CONTACT?.STATE_ERROR_DEFAULT,
                                fieldLevelErrorData,
                                'state',
                                'addEditErrors'
                              ),
                              112: getFieldErrorMessage(
                                CONTACT?.EDIT_STATE_ERROR,
                                fieldLevelErrorData,
                                'state',
                                'addEditErrors'
                              ),
                              114: getFieldErrorMessage(
                                CONTACT?.EDIT_STATE_ERROR,
                                fieldLevelErrorData,
                                'state',
                                'addEditErrors'
                              )
                            }
                          },
                          {
                            field: 'postalCode',
                            label: `${CONTACT?.EDIT_ZIP}`,
                            errors: {
                              default: getFieldErrorMessage(
                                CONTACT?.ZIPCODE_ERROR_DEFAULT,
                                fieldLevelErrorData,
                                'zipcode',
                                'addEditErrors'
                              ),
                              113: getFieldErrorMessage(
                                CONTACT?.EDIT_ZIPCODE_ERROR,
                                fieldLevelErrorData,
                                'zipcode',
                                'addEditErrors'
                              ),
                              114: getFieldErrorMessage(
                                CONTACT?.EDIT_ZIPCODE_ERROR,
                                fieldLevelErrorData,
                                'zipcode',
                                'addEditErrors'
                              )
                            }
                          },
                          {
                            field: 'county',
                            label: 'County',
                            errors: {
                              default: 'Custom error text'
                            }
                          }
                        ]}
                        statusUpdateCallback={(addressObj) => {
                          const newObj = { ...addressObj }

                          if (newObj.address1 === '') {
                            newObj.address1 = {
                              inputValue:
                                formValues.addressCollection.address1
                                  .inputValue,
                              errorCode: 0
                            }
                          }
                          if (newObj.address2 === '') {
                            newObj.address2 = {
                              inputValue:
                                formValues.addressCollection.address2
                                  .inputValue,
                              errorCode: 0
                            }
                          }
                          if (newObj.city === '') {
                            newObj.city = {
                              inputValue:
                                formValues.addressCollection.city.inputValue,
                              errorCode: 0
                            }
                          }
                          if (newObj.state === '') {
                            newObj.state = {
                              inputValue:
                                formValues.addressCollection.state.inputValue,
                              errorCode: 0
                            }
                          }
                          if (newObj.postalCode === '') {
                            newObj.postalCode = {
                              inputValue:
                                formValues.addressCollection.postalCode
                                  .inputValue,
                              errorCode: 0
                            }
                          }
                          handleStatusUpdate({ ...newObj })
                        }}
                        showFilterErrors
                        collectionErrorCounts={[
                          {
                            field: 'address1',
                            dynamicErrorCount:
                              incrementErrorCountsForFieldLevelError(
                                fieldLevelErrorData,
                                'addressLine1',
                                addressCollectionErrorCount.address1
                              )
                          },
                          {
                            field: 'address2',
                            dynamicErrorCount: addressCollectionErrorCount
                          },
                          {
                            field: 'city',
                            dynamicErrorCount:
                              incrementErrorCountsForFieldLevelError(
                                fieldLevelErrorData,
                                'city',
                                addressCollectionErrorCount.city
                              )
                          },
                          {
                            field: 'state',
                            dynamicErrorCount:
                              incrementErrorCountsForFieldLevelError(
                                fieldLevelErrorData,
                                'state',
                                addressCollectionErrorCount.state
                              )
                          },
                          {
                            field: 'postalCode',
                            dynamicErrorCount:
                              incrementErrorCountsForFieldLevelError(
                                fieldLevelErrorData,
                                'zipcode',
                                addressCollectionErrorCount.zipcode
                              )
                          },
                          {
                            field: 'county',
                            dynamicErrorCount: addressCollectionErrorCount
                          }
                        ]}
                      />
                    )}
                </>
              ))}
            </div>
          </>
        )}
      </BlockLayout>

      <BlockLayout
        actAs="Shell"
        gapOnTop={isOLBOrIpadApp() ? '8' : '0'}
        mobileBottomMargin="0"
      >
        {isScheduled && (
          <section className="usb-tg-caption usb-c-gray-80">
            {REMOVEBILLPOPUP?.scheduleBill}
          </section>
        )}
        {isAutopayment && (
          <section className="usb-tg-caption">
            {REMOVEBILLPOPUP?.autopayBill}
          </section>
        )}
      </BlockLayout>
    </>
  )
}

EditDetails.propTypes = {
  formValues: PropTypes.objectOf(PropTypes.any).isRequired,
  phoneNumberRef: PropTypes.objectOf(PropTypes.any).isRequired,
  phoneNumberErrorCount: PropTypes.number.isRequired,
  handleStatusUpdate: PropTypes.func.isRequired,
  addressCollectionErrorCount: PropTypes.objectOf(PropTypes.any).isRequired,
  addressCollectionRef: PropTypes.objectOf(PropTypes.any).isRequired,
  googleAPIkey: PropTypes.string.isRequired,
  fieldLevelErrorData: PropTypes.objectOf(PropTypes.any).isRequired,
  isPayeeCategoryBusiness: PropTypes.bool.isRequired,
  isHideAccountNumber: PropTypes.bool.isRequired,
  accountNumberErrorCount: PropTypes.number,
  accountNumberRef: PropTypes.objectOf(PropTypes.any).isRequired,
  payee: PropTypes.objectOf(PropTypes.any),
  billerLogoUrl: PropTypes.func,
  nickName: PropTypes.string.isRequired,
  setNickName: PropTypes.func.isRequired,
  isScheduled: PropTypes.string,
  isAutopayment: PropTypes.bool.isRequired,
  modifiableFields: PropTypes.arrayOf(PropTypes.any).isRequired,
  isPersonBiller: PropTypes.bool.isRequired,
  companyRef: PropTypes.objectOf(PropTypes.any).isRequired,
  personNameRef: PropTypes.objectOf(PropTypes.any).isRequired,
  name: PropTypes.string.isRequired,
  setName: PropTypes.func.isRequired,
  companyErrorCount: PropTypes.number,
  personNameErrorCount: PropTypes.number
}
EditDetails.defaultProps = {
  accountNumberErrorCount: null,
  companyErrorCount: null,
  personNameErrorCount: null,
  payee: {},
  billerLogoUrl: null,
  isScheduled: ''
}

export default EditDetails
